<div
  style="
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  "
>
  <div>
    <div
      *ngIf="formControl.value as item"
      style="display: flex; align-items: center"
    >
      <p style="margin-top: 0; margin-right: 10px">Code : {{ item.warehouseCode }}</p>
      <a
        class="button-ghost"
        [routerLink]="['/extensions', 'ware-house', item.id]"
        target="_blank"
      >
      {{ "common.details" | translate }}
        <clr-icon shape="link"></clr-icon>
      </a>
    </div>
  </div>

  <!-- <button class="btn btn-primary" (click)="create()">
    Create new warehouse
  </button> -->
</div>

<ng-select
  [items]="items$ | async"
  appendTo="body"
  bindLabel="name"
  [addTag]="false"
  [multiple]="false"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="0"
  [loading]="isLoading"
  [typeahead]="input$"
  [formControl]="formControl"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="item-row">
      <clr-icon shape="user" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.warehouseCode }} - {{ item.warehouseName }}</span>
    </span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span class="item-row">
      <clr-icon shape="user" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.warehouseCode }} - {{ item.warehouseName}}</span>
    </span>
  </ng-template>
</ng-select>
